import { IncidentPosition } from 'hooks/incident/useRoster';

/**
 * Positions inside the subtree of `positionId`, which cannot be reported to
 * without creating a cycle.
 */
export const getDescendantIds = (
  positions: IncidentPosition[],
  positionId: string
): Set<string> => {
  const descendants = new Set<string>();
  let frontier = [positionId];

  while (frontier.length > 0) {
    const children = positions.filter(
      (position) =>
        position.parent_id &&
        frontier.includes(position.parent_id) &&
        !descendants.has(position.id)
    );
    children.forEach((child) => descendants.add(child.id));
    frontier = children.map((child) => child.id);
  }

  return descendants;
};
